var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileLoyaltyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.90337 8.88583H3.36133C2.42537 8.88583 1.66663 9.65483 1.66663 10.6036V16.6157C1.66663 17.5643 2.42537 18.3334 3.36133 18.3334H5.90337M5.90337 8.88583L8.61604 2.69931C8.99163 1.84276 9.99988 1.40018 10.8175 1.83808C12.09 2.51958 11.8348 3.15837 11.8348 7.16806H16.6382C17.6769 7.16806 18.4711 8.10647 18.3132 9.147L17.14 16.8768C17.0128 17.7148 16.3015 18.3334 15.465 18.3334H5.90337V8.88583ZM5.90337 8.88583V18.3334V8.88583Z",
    stroke: "#EF5DA8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLoyaltyIcon);
export default __webpack_public_path__ + "static/media/mobileLoyaltyIcon.d9a9db7557fc256e6550558bd56bb947.svg";
export { ForwardRef as ReactComponent };